import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spouse } from '../relationships-model';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { AccountInfoRoutes } from '../../../constants/routes';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { RelationshipsProps } from '../../../models/account-info-epi-props';

interface ItemProps {
    spouse: Spouse;
    canAddEdit: boolean;
    basePath?: string;
}

const marriageEndReasonDeceased = 'Deceased Spouse';

export function SpouseDisplay(props: ItemProps) {
    const { spouse, canAddEdit, basePath } = props;

    const relationshipProps = useSelector<TcsmStates, RelationshipsProps>(state => state.epiProps?.relationshipsSettingState?.epiContent);

    const marriageEndReason = () => {
        if (spouse.marriage_end_reason ===  marriageEndReasonDeceased) {
            return relationshipProps.deathDateLabel || 'Date of Death';
        }        
        return relationshipProps.divorceDateLabel || 'Date of Divorce';
    };

    const View = () => {
        if (!spouse) return null;
        
        return (
            <>
                <p>{`${spouse.first_name} ${spouse.person?.middle_name} ${spouse.last_name} ${spouse.person?.suffix}`}</p>
                <p className='grey-caption'>{`${relationshipProps.marriedLabel || 'Date of Marriage'}: ${getFormattedDate(spouse.start_date)}`}</p>
                {!!spouse.legal_separation_date && <p className='grey-caption'>{`${relationshipProps.legalSeparationDateLabel}: ${getFormattedDate(spouse.legal_separation_date)}`}</p>}
                {!!spouse.end_date && <p className='grey-caption'>{`${marriageEndReason()}: ${spouse?.date_of_death ? getFormattedDate(spouse.date_of_death) : getFormattedDate(spouse.end_date)}`}</p>}
            </>
        );
    };

    const AddEdit = () => {
        if (!canAddEdit) return null;

        return (
            <Link to={`${basePath}${AccountInfoRoutes.MaritalStatusSegment}`}>
                {spouse ? 'Edit' : 'Add'}
            </Link>
        );
    };

    return (
        <>
            <View />
            <AddEdit />
        </>

    );
}

SpouseDisplay.defaultProps = {
    basePath: '',
};